/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SimilarRequestSearchContext,
    SimilarRequestSearchContextFromJSON,
    SimilarRequestSearchContextFromJSONTyped,
    SimilarRequestSearchContextToJSON,
    VaultTag,
    VaultTagFromJSON,
    VaultTagFromJSONTyped,
    VaultTagToJSON,
    VaultedInterrogatoryResponseItem,
    VaultedInterrogatoryResponseItemFromJSON,
    VaultedInterrogatoryResponseItemFromJSONTyped,
    VaultedInterrogatoryResponseItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface VaultedInterrogatory
 */
export interface VaultedInterrogatory {
    /**
     * 
     * @type {string}
     * @memberof VaultedInterrogatory
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof VaultedInterrogatory
     */
    text?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VaultedInterrogatory
     */
    sourceId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VaultedInterrogatory
     */
    responseText?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VaultedInterrogatory
     */
    firmId?: string;
    /**
     * 
     * @type {string}
     * @memberof VaultedInterrogatory
     */
    documentId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VaultedInterrogatory
     */
    clientId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VaultedInterrogatory
     */
    jurisdictionId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VaultedInterrogatory
     */
    userId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VaultedInterrogatory
     */
    title?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VaultedInterrogatory
     */
    interrogatoryId?: number | null;
    /**
     * 
     * @type {SimilarRequestSearchContext}
     * @memberof VaultedInterrogatory
     */
    context?: SimilarRequestSearchContext;
    /**
     * 
     * @type {Date}
     * @memberof VaultedInterrogatory
     */
    createdDate?: Date;
    /**
     * 
     * @type {Array<VaultTag>}
     * @memberof VaultedInterrogatory
     */
    vaultTags?: Array<VaultTag> | null;
    /**
     * 
     * @type {Array<VaultTag>}
     * @memberof VaultedInterrogatory
     */
    normalizedVaultTags?: Array<VaultTag> | null;
    /**
     * 
     * @type {{ [key: string]: Array<VaultedInterrogatoryResponseItem>; }}
     * @memberof VaultedInterrogatory
     */
    responseList?: { [key: string]: Array<VaultedInterrogatoryResponseItem>; } | null;
}

export function VaultedInterrogatoryFromJSON(json: any): VaultedInterrogatory {
    return VaultedInterrogatoryFromJSONTyped(json, false);
}

export function VaultedInterrogatoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): VaultedInterrogatory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'text': !exists(json, 'text') ? undefined : json['text'],
        'sourceId': !exists(json, 'sourceId') ? undefined : json['sourceId'],
        'responseText': !exists(json, 'responseText') ? undefined : json['responseText'],
        'firmId': !exists(json, 'firmId') ? undefined : json['firmId'],
        'documentId': !exists(json, 'documentId') ? undefined : json['documentId'],
        'clientId': !exists(json, 'clientId') ? undefined : json['clientId'],
        'jurisdictionId': !exists(json, 'jurisdictionId') ? undefined : json['jurisdictionId'],
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'interrogatoryId': !exists(json, 'interrogatoryId') ? undefined : json['interrogatoryId'],
        'context': !exists(json, 'context') ? undefined : SimilarRequestSearchContextFromJSON(json['context']),
        'createdDate': !exists(json, 'createdDate') ? undefined : (new Date(json['createdDate'])),
        'vaultTags': !exists(json, 'vaultTags') ? undefined : (json['vaultTags'] === null ? null : (json['vaultTags'] as Array<any>).map(VaultTagFromJSON)),
        'normalizedVaultTags': !exists(json, 'normalizedVaultTags') ? undefined : (json['normalizedVaultTags'] === null ? null : (json['normalizedVaultTags'] as Array<any>).map(VaultTagFromJSON)),
        'responseList': !exists(json, 'responseList') ? undefined : json['responseList'],
    };
}

export function VaultedInterrogatoryToJSON(value?: VaultedInterrogatory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'text': value.text,
        'sourceId': value.sourceId,
        'responseText': value.responseText,
        'firmId': value.firmId,
        'documentId': value.documentId,
        'clientId': value.clientId,
        'jurisdictionId': value.jurisdictionId,
        'userId': value.userId,
        'title': value.title,
        'interrogatoryId': value.interrogatoryId,
        'context': SimilarRequestSearchContextToJSON(value.context),
        'createdDate': value.createdDate === undefined ? undefined : (value.createdDate.toISOString()),
        'vaultTags': value.vaultTags === undefined ? undefined : (value.vaultTags === null ? null : (value.vaultTags as Array<any>).map(VaultTagToJSON)),
        'normalizedVaultTags': value.normalizedVaultTags === undefined ? undefined : (value.normalizedVaultTags === null ? null : (value.normalizedVaultTags as Array<any>).map(VaultTagToJSON)),
        'responseList': value.responseList,
    };
}


